import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  InputGroup,
  Button,
  Breadcrumb,
  Pagination,
  Nav,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../../components/UploadImageComponent";
import InputLeftIcon from "../../components/form_item/InputLeftIcon";
import { SuccessSwal } from "../../helpers/alertseet";
import peopleImage from "../../assets/people.jpeg";
import { useNavigate, useParams } from "react-router-dom";
import PopUpPayLoan from "../../components/popup/PopUpPayLoan";
import { get_loan_by_id } from "../../services/loan.service";
import { useStore } from "../../store";
import moment from "moment";
import converSex from "../../helpers/convertSex";
import convertPercent from "../../helpers/convertPercent";
import convertNumber from "../../helpers/convertNumber";
import convertStatusLoan from "../../helpers/convertStatusLoan";
import cutBranchNo from "../../helpers/cutBranchNo";

export default function LoanDetailMembershipPage() {
  const navigate = useNavigate();
  const { loanId } = useParams();
  // state
  const [isLoading, setIsLoading] = useState(true);
  const [popup, setPopup] = useState();
  const [loanData, setLoanData] = useState();

  // store
  const { token } = useStore();

  // useEffect
  useEffect(() => {
    getData();
  }, []);

  // function
  const getData = async () => {
    try {
      setIsLoading(true);
      const data = await get_loan_by_id(loanId, "", token);
      if (data?.error) throw new Error(data?.message);
      let loan = data?.data;

      setLoanData(loan);
      setIsLoading(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  const handlePayLoan = async () => {
    setPopup();
    SuccessSwal("ສຳເລັດ!");
  };
  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => navigate("/loan", { replace: true })}>
          ປ່ອຍກູ້ ແລະ ເກັບຄືນ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ລາຍລະອຽດ</Breadcrumb.Item>
      </Breadcrumb>

      <Card
        style={{
          padding: "20px 20px",
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 150,
        }}
      >
        <h2>ຂໍ້ມູນປ່ອຍກູ້</h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 20,
            gridGap: 20,
            width: "100%",
            marginBottom: 20,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                {
                  title: "ເລກສະມາຊິກ:",
                  value: loanData?.memberId?.memberNo
                    ? cutBranchNo(loanData?.memberId?.memberNo)
                    : "-",
                },
                {
                  title: "ຊື່ ແລະ ນາມສະກຸນ:",
                  value: loanData?.memberId?.fullName || "-",
                },
                {
                  title: "ເພດ:",
                  value: loanData?.memberId?.gender
                    ? converSex(loanData?.memberId?.gender)
                    : "-",
                },
                { title: "ເບີໂທ:", value: loanData?.memberId?.phone || "-" },
                {
                  title: "ຜູ້ສ້າງລາຍການ:",
                  value: loanData?.createdBy?.fullName || "-",
                },
                {
                  title: "ວັນເວລາປ່ອຍກູ້:",
                  value: loanData?.createdAt
                    ? moment(loanData?.createdAt).format("DD/MM/YYYY HH:mm")
                    : "-",
                },
                {
                  title: "ເອກະສານສັນຢາ:",
                  value: <span style={{ color: "#0178C1" }}>ຮູບພາບ</span>,
                },
              ].map((e, i) => (
                <div className="list-data" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {/* <h2>ຂໍ້ມູນສ່ວນໂຕ</h2> */}
              {[
                {
                  title: "ງວດຊຳລະ:",
                  value: (
                    <>
                      <span style={{ color: "#0178C1" }}>
                        {loanData?.latestInstallmentNote?.installmentNoteNo ||
                          "-"}
                      </span>{" "}
                      / {loanData?.loanTerm || "-"}
                    </>
                  ),
                },
                {
                  title: "ຈຳນວນເງິນທີ່ຊຳລະ (ກີບ) ",
                  value: loanData?.totalRepaymentAmount
                    ? convertNumber(loanData?.totalRepaymentAmount)
                    : "-",
                },
                {
                  title: "ຈຳນວນເງິນກູ້ (ກີບ):",
                  value: (
                    <span style={{ color: "#0178C1" }}>
                      {loanData?.loanAmount
                        ? convertNumber(loanData?.loanAmount)
                        : "-"}
                    </span>
                  ),
                },
                {
                  title: `ດອກເບ້ຍ ${
                    loanData?.interestRate
                      ? convertPercent(loanData?.interestRate)
                      : "-"
                  }/ເດືອນ (ກີບ):`,
                  value: "-",
                },

                {
                  title: "ໄລຍະເວລາ:",
                  value: `${loanData?.loanTerm || "-"} ເດືອນ`,
                },
                { title: "ຈຳນວນເງິນທີ່ຍັງບໍ່ຊຳລະ (ກີບ):", value: "-" },
                // { title: "ຮູບແບບກາາຊຳລະດອກເບ້ຍ:", value: "-" },
              ].map((e, i) => (
                <div className="list-data" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <h2>ຕາຕະລາງເກັບຄືນ</h2>
        <div className="list-data" style={{ marginBottom: 20 }}>
          <div>ຮູບແບບກາາຊຳລະດອກເບ້ຍ:</div>
          <div>-</div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "flex-end" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Form.Label>ສະແດງຕາມສະຖານະ</Form.Label>
            <Form.Select aria-label="Default select example">
              <option>ທັງໝົດ</option>
              <option value="ລໍຖ້າຊຳລະ">ລໍຖ້າຊຳລະ</option>
              <option value="ບໍ່ຮອດມື້ຊຳລະ">ບໍ່ຮອດມື້ຊຳລະ</option>
              <option value="ຊຳລະສຳເລັດ">ຊຳລະສຳເລັດ</option>
              <option value="ທັງໝົດ">ທັງໝົດ</option>
            </Form.Select>
          </div>
          <div style={{ flex: 1 }}></div>
          {/* <div>
            <Button size="md">ຊຳລະເງິນ</Button>
          </div> */}
        </div>
        <div style={{ overflow: "auto" }}>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>ງວດທີ</th>
                <th style={{ textAlign: "end" }}>ຈຳນວນເງິນຕົ້ນ (ກີບ)</th>
                <th style={{ textAlign: "end" }}>ດອກເບ້ຍ (ກີບ)</th>
                <th style={{ textAlign: "end" }}>ຄ່າປັບໃໝ (ກີບ)</th>
                <th>ວັນທີ່ຕ້ອງຊຳລະເງິນ</th>
                <th>ສະຖານະ</th>
              </tr>
            </thead>
            <tbody>
              {loanData?.installmentNotes?.map((e, i) => (
                <tr key={i}>
                  <td>{e?.installmentNoteNo}</td>
                  <td style={{ textAlign: "end" }}>
                    {e?.totalRepayment ? convertNumber(e?.totalRepayment) : "-"}
                  </td>
                  <td style={{ textAlign: "end" }}>-</td>
                  <td style={{ textAlign: "end" }}>
                    {e?.lateFeesAmount ? convertNumber(e?.lateFeesAmount) : "-"}
                  </td>
                  <td>
                    {e?.dueDate ? moment(e?.dueDate).format("DD/MM/YYYY") : "-"}
                  </td>
                  <td>
                    {e?.installmentStatus
                      ? convertStatusLoan(e?.installmentStatus)
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
      {/* popup */}
      <PopUpPayLoan
        open={popup?.PopUpPayLoan}
        onClose={() => setPopup()}
        onSubmit={handlePayLoan}
      />
    </div>
  );
}
